import React from "react";

const FootNote = () => {
  return (
    <React.Fragment>
      <div className="footnote-blk">
        <p>
          By using CX Perspectives, you agree to our Terms and have read our
          Privacy Policy.
        </p>
      </div>
    </React.Fragment>
  );
};

export default FootNote;
